import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';
import Logo from './ui-elements/Logo';

class Footer extends Component {

  render() {
    return (
      <footer className='footer container-fluid bg-white py-3 px-3 d-flex justify-content-between'>
        <div className="d-none d-md-block">
          <Logo size="xs" gray={true} text={true} className="m-0"/>
        </div>
        <nav className="nav justify-content-start justify-content-sm-end">
          <small className="nav-link d-none d-md-block">© 2018</small>
          <a className="nav-link paul-nav-link" href='https://twitter.com/paulopensearch' rel="noopener noreferrer" target='_blank'>
            <i className="fab fa-twitter" style={{ transform: 'scale(1.3)' }}></i>
          </a>
          <HashLink to='/content#top' className='nav-link paul-nav-link'>Inhalte</HashLink>
          <HashLink to='/about#top' className='nav-link paul-nav-link'>Über uns</HashLink>
          <HashLink to='/imprint#top' className="nav-link paul-nav-link">Impressum/Datenschutz</HashLink>
        </nav>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js